export const TEST_STEPS = {
  INTRO: 'intro',
  PROGRESS: 'progress',
  RESULTS: 'results',
};

export const PROGRESS_STEPS = {
  INIT: 0,
  START: 5,
  CONNECTION_TEST_PASSED: 10,
  QUALITY_LIMIT: 95,
  DONE: 100,
};

export const TEST_RESULT_QUALITY = {
  EXCELLENT: {
    min: 3.8,
    max: 4.5,
    id: 'virtualVisit.test.result.excellent',
    danger: false,
    icon: 'mic',
  },
  GOOD: {
    min: 3.1,
    max: 3.79,
    id: 'virtualVisit.test.result.good',
    danger: false,
    icon: 'mic',
  },
  FAIR: {
    min: 2.4,
    max: 3.09,
    id: 'virtualVisit.test.result.fair',
    danger: true,
    icon: 'mic',
  },
  POOR: {
    min: 1.7,
    max: 2.39,
    id: 'virtualVisit.test.result.poor',
    danger: true,
    icon: 'mic',
  },
  BAD: {
    min: 1.0,
    max: 1.69,
    id: 'virtualVisit.test.result.bad',
    danger: true,
    icon: 'mic',
  },
  NOT_FOUND: {
    id: 'virtualVisit.test.deviceNotFound',
    titleId: 'virtualVisit.test.result.failure',
    danger: true,
    icon: 'sound-on-error',
    videoIcon: 'video-on-error',
  },
};



// WEBPACK FOOTER //
// ./src/components/VirtualVideoTest/constants/index.js